export default __webpack_public_path__ + "static/media/contact-05.d4a9b1a1.png";